import * as React from 'react';
import {FunctionComponent, PropsWithChildren} from 'react';

interface OwnProps {}

export const Container: FunctionComponent<OwnProps & PropsWithChildren> = ({children}) => {
    return <div className="container-fluid flex-grow-1">{children}</div>;
};
